import { css } from '@/styled-system/css';

export const fallbackSurface = css({
  position: 'relative',
  display: 'block',
  width: '100%',
  height: '100%',
  minWidth: 0,
  minHeight: 0,
  background: 'bg.softest',
});
